import styled from 'styled-components';

export const AmigoSection = styled.section`
    width: 100%;
    background-color: #7d00ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 24px;

    box-sizing: border-box;
    @media (max-width: 792px) {
        padding: 24px;
    }
`;

export const AmigoContent = styled.div`
    width: 100%;
    max-width: 1110px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;

    @media (max-width: 792px) {
        flex-direction: column-reverse;
        & img {
            min-width: stretch;
        }
    }
`;

export const AmigoTextBlock = styled.div`
    color: #fff;
    flex: 1 1 320px;

    @media (max-width: 792px) {
        flex: 1;
    }
`;

export const AmigoTitle = styled.p`
    margin: 0;
    font-size: 60px;
    line-height: 68px;
    font-family: Amigo;
    font-weight: 900;
`;

export const AmigoButton = styled.button`
    font-family: Amigo;
    display: inline-block;
    margin-top: 20px;
    background-color: rgb(224, 0, 93);
    color: #ffffff;
    text-decoration: none;
    font-weight: 700;
    padding: 12px 24px;
    border-radius: 999px;
`;

export const AmigoImage = styled.img`
    flex: 1 1 320px;
    max-width: 400px;
    width: 100%;
    height: auto;
    object-fit: contain;
    align-self: flex-end;
`;
